// Countries, from the runtime rather than from a list we typed out.
//
// The manual-location form needs a country, and hardcoding a handful would
// quietly cap where this app works. Instead the codes are walked and named by
// Intl.DisplayNames, so the list is whatever the platform actually knows —
// complete, localised, and not a coverage claim of ours.
//
// Availability is real coverage: a country appearing here only means we can
// name it and geocode into it, never that we found shops there.
//
// NOT a mock.

const A = 'A'.charCodeAt(0);

let cache = null;

export function listCountries(locale = 'en') {
  if (cache) return cache;

  let names;
  try {
    names = new Intl.DisplayNames([locale], { type: 'region' });
  } catch {
    // Old runtime, no DisplayNames. The form falls back to a plain code field
    // rather than pretending to a list.
    cache = [];
    return cache;
  }

  const found = [];
  for (let first = 0; first < 26; first += 1) {
    for (let second = 0; second < 26; second += 1) {
      const code = String.fromCharCode(A + first, A + second);
      let name;
      try {
        name = names.of(code);
      } catch {
        continue;
      }
      // An unassigned code comes back as itself. That is the only reliable
      // signal that the platform does not recognise it.
      if (name && name !== code) found.push({ code, name });
    }
  }

  found.sort((a, b) => a.name.localeCompare(b.name, locale));
  cache = found;
  return cache;
}

// Only ever a default for the form's country field — never used to decide
// where the user is.
export function regionFromLocale(locale) {
  const tag = locale || (typeof navigator !== 'undefined' ? navigator.language : null);
  if (!tag) return null;
  try {
    return new Intl.Locale(tag).region ?? null;
  } catch {
    const parts = String(tag).split('-');
    return parts.length > 1 && /^[A-Za-z]{2}$/.test(parts[1]) ? parts[1].toUpperCase() : null;
  }
}
